var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_3725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20.4998V21.505H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_3725)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.717 14.2911C12.921 14.2911 13.901 15.2641 13.901 16.4601V19.5361C13.901 19.7931 14.107 19.9991 14.371 20.0051H16.277C17.779 20.0051 19 18.7991 19 17.3171V8.59313C18.993 8.08313 18.75 7.60313 18.333 7.28413L11.74 2.02613C10.855 1.32513 9.617 1.32513 8.729 2.02813L2.181 7.28213C1.748 7.61113 1.505 8.09113 1.5 8.61013V17.3171C1.5 18.7991 2.721 20.0051 4.223 20.0051H6.147C6.418 20.0051 6.638 19.7901 6.638 19.5261C6.638 19.4681 6.645 19.4101 6.657 19.3551V16.4601C6.657 15.2711 7.631 14.2991 8.826 14.2911H11.717ZM16.277 21.5051H14.353C13.251 21.4791 12.401 20.6141 12.401 19.5361V16.4601C12.401 16.0911 12.094 15.7911 11.717 15.7911H8.831C8.462 15.7931 8.157 16.0941 8.157 16.4601V19.5261C8.157 19.6011 8.147 19.6731 8.126 19.7411C8.018 20.7311 7.172 21.5051 6.147 21.5051H4.223C1.894 21.5051 0 19.6261 0 17.3171V8.60313C0.01 7.60913 0.468 6.69913 1.259 6.10013L7.794 0.855128C9.233 -0.284872 11.238 -0.284872 12.674 0.853128L19.256 6.10313C20.029 6.69213 20.487 7.60013 20.5 8.58213V17.3171C20.5 19.6261 18.606 21.5051 16.277 21.5051V21.5051Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6bc0737a453b2893c89b646423d499ab.svg";
export { ForwardRef as ReactComponent };